export const blockfrostApiGet = async ( uri ) => {
    let settings= {};
    settings = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "project_id": "mainnet72YAKKoPkIInf3kjqXKx4lhsusmB4GOU",
      },
      // body: JSON.stringify(jsonRaw),
      redirect: 'follow',
      mode: 'cors',
    };
    try {
      const fetchResponse = await fetch(`https://cardano-mainnet.blockfrost.io/api/v0/${uri}`, settings);
      const data = await fetchResponse.json();
      console.log(data);
      return(data);
    } catch (e) {
      // console.log(e);
      return e;
    };  
};